import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './content/store';  
import { AuthProvider } from "./content/AuthContext";
import App from './App';
import { authHydrate } from './content/auth';
import RouteTracker from './RouteTracker';

store.dispatch(authHydrate());

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
    <RouteTracker />
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);